<div class="driver-exercise-card">
  <div class="top-card">
    <div class="left-card" (click)="goToProtocol()">
      <div class="text">
        <div class="title">
          {{ protocol()?.name | truncate: 25 }}
          <mat-icon style="color:#2D3872">chevron_right</mat-icon>
        </div>
      </div>
    </div>
    <div class="right-card">
      <button mat-icon-button matTooltip="Crear una copia del protocolo" (click)="copyProtocol($event)">
        <mat-icon>file_copy</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="bottom-card">
    <div class="bottom-information">
      <div class="info-item">
        <div class="subtitle">REGLAS</div>
        <div class="title">{{ ruleGroupCount() }}</div>
      </div>
      <div class="info-item">
        <div class="subtitle">OPERATIVAS</div>
        <div class="title">{{ operativaCount() }}</div>
      </div>
    </div>
  </div>
</div>